import React from 'react';

export default function TabBar({ tabs, activeTab, setActiveTab, entries, characters }) {
  const getCount = (tabId) => {
    if (tabId === 'characters') return characters.length;
    if (tabId === 'recap') return null;
    if (tabId === 'all') return entries.length;
    return entries.filter(e => e.type === tabId).length;
  };

  return (
    <div className="flex gap-1.5 px-4 bg-ink/10 overflow-x-auto mt-6 rounded-t-lg pt-2">
      {tabs.map(tab => {
        const count = getCount(tab.id);
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`
              bg-parchment-mid border-[1.5px] border-parchment-dark border-b-0 rounded-t-[5px] px-4 py-2 font-lora text-[0.84rem] cursor-pointer transition-all whitespace-nowrap
              ${isActive
                ? 'bg-parchment text-ink font-medium mt-[2px] shadow-[0_-2px_8px_rgba(44,36,22,0.18)] z-10 border-b-parchment relative'
                : 'text-ink-mid hover:bg-parchment hover:text-ink mt-[6px]'}
            `}
          >
            {tab.icon} {tab.label}
            {count !== null && (
              <span className="inline-block bg-parchment-dark rounded-full px-2 text-[0.7rem] ml-1.5 font-lora text-ink-light">
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}